import request from '@/utils/request'

/** 获取图形验证码 */
export function getCaptcha(time) {
  return `${process.env.VUE_APP_BASE_API}/backend/captcha.png?time=${time}`
}

/** 管理员登录 */
export function login(data) {
  return request.post(`/backend/admin/login`, data)
}

/** 获取当前登录管理员信息 */
export function getInfo() {
  return request.get(`/backend/admin/info`)
}

/** 当前管理员退出系统 */
export function logout() {
  return request.post('/backend/admin/logout')
}
